import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Stack,
         TextField, Button, Input, CircularProgress, } from '@mui/material';
import React, { useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { hasPermission } from 'src/components/Permissions/hasPermission';
import { multy_post, post } from 'src/services/httpClient.service';

const CreateReconciliation = () => {
  const [requestType, setRequestType] = useState('All');
  const [reconcileType, setReconcileType] = useState('STB_PACKAGE');
  const [dateTime, setSelectedDateTime] = useState<Dayjs | null>(dayjs());
  const [remarks, setRemarks] = useState('');
  const [file, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      setFileName(file.name);
    }
  };

  const handleSubmit = async () => {
    // if (!file) {
    //   showSnackbar('Please select a file to upload', 'error');
    //   return;
    // }

    setIsSubmitting(true);

    const formData = new FormData();
    //formData.append('file', file);
    formData.append('requestType', requestType);
    formData.append('reconcileType', reconcileType);
    formData.append('date', dateTime?.format('YYYY-MM-DD HH:mm:ss') || '');
    formData.append('remarks', remarks);

    try {
      const response = await multy_post(
        //`${process.env.REACT_APP_BASE_API_URL}/api/reconcile/upload`,
        `${process.env.REACT_APP_BASE_API_URL}/api/reconcile/initiate-reconciliation`,
        formData);

      showSnackbar('Reconciliation submitted successfully', 'success');

      // Reset form
      setRequestType('All');
      setReconcileType('STB_PACKAGE');
      setSelectedDateTime(dayjs());
      setRemarks('');
      setSelectedFile(null);
      setFileName('');
    } catch (error: any) {
      console.error('Upload error:', error);
      showSnackbar(
        error.response?.data?.message || 'Failed to submit reconciliation',
        'error'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ '& .MuiPageTitle-wrapper': { height: '80px' }, paddingX: "15px" }}>
        <PageTitleWrapper>
          <PageTitle heading="Create Reconciliation" handleClick={undefined} />
        </PageTitleWrapper>
      </Box>

      <Box>
        {isSubmitting ? (
          <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ width: '100%', padding: "10px 20px" }}>
            <Box sx={{ mt: 6 }}>
              <Stack direction="row" spacing={3} alignItems="center">
                {/* Request Type Dropdown */}
                {/* <FormControl sx={{ minWidth: 250 }} size="small">
                  <InputLabel>Request Type</InputLabel>
                  <Select
                    value={requestType}
                    onChange={(e) => setRequestType(e.target.value)}
                    label="Request Type"
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="ACTIVE">Active</MenuItem>
                    <MenuItem value="INACTIVE">In-active</MenuItem>
                  </Select>
                </FormControl> */}

                {/* Reconciliation Type Dropdown */}
                <FormControl sx={{ minWidth: 250 }} size="small">
                  <InputLabel>Reconciliation Type</InputLabel>
                  <Select
                    value={reconcileType}
                    onChange={(e) => setReconcileType(e.target.value)}
                    label="Reconciliation Type"
                  >
                    <MenuItem value="STB_PACKAGE">STB Reconciliation</MenuItem>
                    <MenuItem value="PACKAGE_CHANNEL">Package/Channel Reconciliation</MenuItem>
                  </Select>
                </FormControl>

                {/* DateTime Picker */}
                <DateTimePicker
                  label="Date & Time"
                  value={dateTime}
                  onChange={(newValue) => setSelectedDateTime(newValue)}
                  sx={{ width: 250, '& .MuiInputBase-input': { height: '5px' } }}
                />
              </Stack>

              {/* File Upload */}
              {/* <Box sx={{ marginTop: "50px" }}>
                <Input
                  type="file"
                  id="file-upload"
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />
                <label htmlFor="file-upload">
                  <Button
                    variant="contained"
                    component="span"
                    startIcon={<CloudUploadIcon />}
                    sx={{ mr: 2 }}
                  >
                    Upload File
                  </Button>
                </label>
                <Typography variant="body1" component="span">
                  {fileName || 'No file selected'}
                </Typography>
              </Box> */}

              {/* Remarks Textarea */}
              <Box sx={{ mt: 3, width: '100%' }}>
                <TextField
                  label="Remarks"
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter any additional remarks here..."
                />
              </Box>

              {/* Submit Button */}
              <Box sx={{ mt: 3 }}>
                {
                  hasPermission(["OWNER", "reconciliation.create"]) && 
                  (<Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
                 >
                  Submit Reconciliation
                 </Button>)
                }     
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default CreateReconciliation;